import React from "react";
import { connect, useSelector } from "react-redux";
import bracketLogo from "../../img/navigation/Bracket.svg";
import discountLogo from "../../img/navigation/Discount.svg";
import InfoIcon from "@mui/icons-material/Info";
import { Tooltip } from "@mui/material";
import {
  selectIsOverlayVisible,
  toggleOverlay,
} from "../../store/slices/headerSlice";
import {
  calculateDealerPrice,
  calculateUpdatedDiscountPercentage,
  formatWithCommasWithDecimal,
} from "../../utils/utils";

function MobilePrice({ selectProduct, isOverlayVisible, toggleOverlay }) {
  const selectedVariant = useSelector(
    (state) => state.productDetail.selectedVariant
  );

  const discount =
    calculateUpdatedDiscountPercentage(
      selectedVariant?.MRP_price,
      selectedVariant?.NDP_Price,
      selectProduct && selectProduct[0]?.GST
    ) || 0;

  return (
    <div className="w-full flex flex-col px-4 py-2 bg-white">
      {/* 🔹 Price Row */}
      <div className="flex items-center justify-start w-full">
        {/* Left Section (Sale + MRP) */}
        <div className="flex flex-col items-start justify-start font-[Space_Grotesk]">
          {/* Sale Price */}
          <div className="flex items-center mb-1">
            <span className="text-gray-800 font-semibold text-[14px] w-[70px]">
              Sale Price
            </span>
            <span className="text-blue font-bold text-[18px] ml-2">
              ₹
              {selectedVariant?.NDP_Price &&
                formatWithCommasWithDecimal(
                  calculateDealerPrice(
                    parseInt(selectedVariant?.NDP_Price),
                    parseInt(selectedVariant?.NDP_Price),
                    parseInt(selectProduct?.[0]?.GST)
                  )
                )}
            </span>
          </div>

          {/* MRP */}
          <div className="flex items-center mt-1">
            <span className="text-gray-800 font-semibold text-[14px]">
              MRP
            </span>
            <span className="text-gray-900 font-medium text-[13px] ml-2 line-through opacity-80">
              ₹
              {formatWithCommasWithDecimal(
                parseInt(selectedVariant?.MRP_price || 0)
              )}
            </span>
          </div>
        </div>

        {/* Divider (Bracket icon) */}
        {discount >= 1 && (
          <>
            <div className="w-auto mx-2">
              <img
                loading="lazy"
                src={bracketLogo}
                alt="divider"
                className="w-[28px] h-auto"
              />
            </div>

            {/* Right Section (Discount info) */}
            <div className="flex items-center justify-center ml-1">
              <div className="flex items-center text-green text-[13px] font-semibold">
                <img
                  loading="lazy"
                  src={discountLogo}
                  alt="discount"
                  className="w-[16px] h-[16px] mr-1"
                />
                <span className="text-[13px] font-bold">{discount}</span>
                <span className="ml-[2px]">%</span>
                <span className="ml-[3px] font-medium">OFF</span>
              </div>
            </div>
          </>
        )}
      </div>

      {/* 🔹 Shipping Info */}
      {selectProduct?.[0]?.Manufacturer === "GARRARI BIKES" && (
        <div className="flex items-center mt-3 text-gray-600 text-[12px] leading-snug">
          <Tooltip
            title="Shipping charges will be collected by the delivery agent upon delivery."
            arrow
            placement="top-start"
          >
            <InfoIcon
              sx={{
                fontSize: "16px",
                color: "gray",
                marginRight: "4px",
                cursor: "pointer",
              }}
            />
          </Tooltip>
          Shipping charges applicable
        </div>
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({
  isOverlayVisible: selectIsOverlayVisible(state),
});

const mapDispatchToProps = {
  toggleOverlay,
};

export default connect(mapStateToProps, mapDispatchToProps)(MobilePrice);
